import { Navigate, Route, Routes } from 'react-router-dom'
import EtaHistory from './EtaHistory'

export default function EtaHistoryRoutes() {
    return (
        <Routes>
            <Route index element={<EtaHistory />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
